import { render, staticRenderFns } from "./orderCustomizeChartered.vue?vue&type=template&id=5b5cbaac"
import script from "./orderCustomizeChartered.vue?vue&type=script&lang=js"
export * from "./orderCustomizeChartered.vue?vue&type=script&lang=js"
import style0 from "./orderCustomizeChartered.vue?vue&type=style&index=0&id=5b5cbaac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports